var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDb4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefaed",
      stroke: "none"
    },
    d: "M0 0L0 178C6.01292 175.684 13.8398 174.085 13.6011 166C13.4466 160.767 7.8255 156.996 12.1921 152.074C16.9382 146.724 20.4994 151.7 26 151.173C34.253 150.382 34.9458 142.552 35 136C37.9237 135.94 42.1014 134.752 44.787 136.117C50.2041 138.871 49.6611 145.043 57.0039 145.512C63.6181 145.935 67.1915 137.2 73.8511 142.124C78.799 145.783 74.605 150.264 75.9159 154.999C78.0889 162.848 86.6679 162 93 162L94.4545 171.485L87.0386 183.004L94.3634 195.59L93 204C86.2894 204 78.0796 202.853 75.6281 211.001C74.2485 215.586 78.4346 220.333 73.8372 223.887C67.0237 229.153 63.0066 219.654 56.0008 220.349C49.1281 221.031 49.5513 227.163 44.6096 229.883C42.0707 231.28 37.8049 230.058 35 230C33.3672 209.31 19.6609 220.034 8 210L8 209C18.1293 199.641 12.0308 189.777 0 188L0 500L500 500L500 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M91 36L92 37L91 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M92 36L92 37L95 37L92 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4826e3",
      stroke: "none"
    },
    d: "M84 38C82.5886 45.5753 81.7783 56.4189 71.4244 56.7531C65.689 56.9382 61.6684 50.9057 56.044 55.3217C45.8085 63.3582 60.0468 71.8691 54.2909 81.8665C50.8741 87.8011 40.7516 85.3553 40.0586 93.0193C38.8924 105.918 50.6363 101.337 54.608 111.012C58.8264 121.287 43.8555 127.813 55.1705 136.642C60.1364 140.517 64.7595 135.027 70 135.258C80.3876 135.717 81.0218 146.26 82 154C85.582 154.463 91.2787 156.837 94.6211 154.933C100.624 151.513 99.68 143.941 108.001 143.144C117.749 142.209 122.617 157.799 132.393 146.366C136.927 141.063 130.418 133.445 136.305 127.059C141.367 121.568 146.027 125.939 151.775 123.397C155.73 121.648 156.972 114.768 158 111C155.916 109.621 153.897 108.215 152.015 106.557C137.356 93.6443 160.85 88.7854 155.981 76.0193C153.105 68.4808 146.72 72.898 141.015 69.9722C131.312 64.9963 134.878 56.3287 136 48C132.881 46.2706 128.775 42.5317 125 42.9822C120.611 43.506 117.989 48.3191 114 49.8163C104.674 53.3171 99.7746 42.6642 97 36L84 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M86 37L87 38L86 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M87.6667 37.3333L88.3333 37.6667L87.6667 37.3333M97 37L98 38L97 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M83 38L84 39L83 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M83.3333 39.6667L83.6667 40.3333L83.3333 39.6667M98 39L99 40L98 39M99 41L100 42L99 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M123 42L124 43L123 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M126 42L127 43L126 42M100 43L101 44L100 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M122 43L123 44L122 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M128 43L129 44L128 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M82 44L83 45L82 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M121 44L122 45L121 44M82 45L82 48L83 48L82 45M101 45L102 46L101 45M120 45L121 46L120 45M131 45L132 46L131 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M102 46L103 47L102 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M133 46L134 47L133 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M102 47L103 48L102 47M134 47L135 48L134 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M103 48L104 49L103 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M116 48L117 49L116 48M136 48L137 49L136 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M106.667 49.3333L107.333 49.6667L106.667 49.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M108 49L109 50L108 49M115 49L116 50L115 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M111.667 50.3333L112.333 50.6667L111.667 50.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M113 50L114 51L113 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M114 50L115 51L114 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M81 51L82 52L81 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M135.333 51.6667L135.667 52.3333L135.333 51.6667M58.6667 52.3333L59.3333 52.6667L58.6667 52.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M60 52L61 53L60 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M57 53L58 54L57 53M62 53L63 54L62 53M79 53L80 54L79 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M56 54L57 55L56 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M64 54L65 55L64 54M77 54L78 55L77 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M55 55L56 56L55 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M66 55L67 56L66 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M67 55L68 56L67 55M75 55L76 56L75 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M134.333 55.6667L134.667 56.3333L134.333 55.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M54 56L55 57L54 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M69 56L70 57L69 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M73 56L74 57L73 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M71 57L72 58L71 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M134 57L135 58L134 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M51 60L52 61L51 60M133 60L134 61L133 60M50.3333 61.6667L50.6667 62.3333L50.3333 61.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M133 61L134 62L133 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M133 62L134 63L133 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M134 63L135 64L134 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M51 64L52 65L51 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M52 66L53 67L52 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M136 66L137 67L136 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M231 66C224.227 77.485 222.503 79.0233 210 82C208.464 77.9469 205.434 71.2972 201.482 69.071C188.815 61.9343 186.946 82.0502 189 89L178 94.9074L162 90L155.128 101L162.481 114L160 126C145.646 127.142 143.492 129.576 141 143C148.548 145.928 161.228 148.962 158.227 160C155.855 168.725 140.765 173.324 152.637 183.382C157.921 187.858 166.038 179.809 171.829 184.357C183.009 193.136 167.664 209.074 184 212.862C192.784 214.899 195.832 201.293 205.985 204.685C217.874 208.658 210.618 226.282 227.853 220.697C235.19 218.319 230.626 205.719 240.004 202.68C251.49 198.958 256.588 217.026 267.642 204.485C272.006 199.534 265.417 193.403 265.812 188C266.105 183.996 270.206 180.478 272 177C284.643 180.018 291.583 179.036 294 165C287.394 160.886 275.703 152.531 283.603 143.637C286.81 140.026 293.438 139.899 295.933 135.61C297.953 132.136 295.303 125.811 295 122C287.377 121.673 270.786 120.88 273.465 108.576C274.407 104.25 278.441 99.5231 281 96L281 95L272 85C266.803 86.4972 260.48 91.9554 255 91.1381C241.396 89.1095 248.993 77.5564 243.972 70.5139C241.707 67.3365 234.581 66.8191 231 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M53 67L54 68L53 67M137 67L138 68L137 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M138 68L139 69L138 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M54 69L55 70L54 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M140 70L141 71L140 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M141 70L141 71L147 71L141 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M147 70L147 71L154 71L147 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M55 71L56 72L55 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M154 71L155 72L154 71M56 72L57 73L56 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M155 73L156 74L155 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M155 74L156 75L155 74M56 76L57 77L56 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M156 76L157 77L156 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M156 77L157 78L156 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M55 78L56 79L55 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M55 79L56 80L55 79M94 79L95 80L94 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M95 79L96 80L95 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefaed",
      stroke: "none"
    },
    d: "M96 79.5332C73.2922 84.5107 81.4412 117.949 104 112.467C124.275 107.54 116.24 75.0966 96 79.5332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M102 79L103 80L102 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M103 79L104 80L103 79M157.333 79.6667L157.667 80.3333L157.333 79.6667M91 80L92 81L91 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M92 80L93 81L92 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M106 80L107 81L106 80M54 81L55 82L54 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M90 81L91 82L90 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M88 82L89 83L88 82M109 82L110 83L109 82M158 82L159 83L158 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M53 83L52 85L53 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M87 83L88 84L87 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M110 83L111 84L110 83M158 83L159 84L158 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M53 84L54 85L53 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M86 84L87 85L86 84M49 85L50 86L49 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M50 85L51 86L50 85M85 85L86 86L85 85M112 85L113 86L112 85M155 85L156 86L155 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M46 86L47 87L46 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M47 86L48 87L47 86M113 86L114 87L113 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M154 86L155 87L154 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M43.6667 87.3333L44.3333 87.6667L43.6667 87.3333M40 88L41 89L40 88M83 88L84 89L83 88M114 88L115 89L114 88M151 88L152 89L151 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M39.3333 89.6667L39.6667 90.3333L39.3333 89.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M150 89L151 90L150 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M115 90L116 91L115 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M39 91L39 96L40 96L39 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M82 91L83 92L82 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M115 91L116 92L115 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M147 91L148 92L147 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M147.333 92.6667L147.667 93.3333L147.333 92.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M116 94L116 99L117 99L116 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M147.333 94.6667L147.667 95.3333L147.333 94.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M81.3333 95.6667L81.6667 96.3333L81.3333 95.6667M39 96L39 102L40 102L39 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M82 100L83 101L82 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M82 101L83 102L82 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M115 101L116 102L115 101M40 102L41 103L40 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M41 102L42 103L41 102M115 102L116 103L115 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M43 103L44 104L43 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M44 103L45 104L44 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M83 103L84 104L83 103M46 104L47 105L46 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M47 104L48 105L47 104M114 104L115 105L114 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M149 104L150 105L149 104M49 105L50 106L49 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M50 105L51 106L50 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M84 105L85 106L84 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M150 105L151 106L150 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M52 106L53 107L52 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M151 106L152 107L151 106M53 107L54 108L53 107M112 107L113 108L112 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M53 108L54 109L53 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M86 108L87 109L86 108M111 108L112 109L111 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M154 108L155 109L154 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M110 109L111 110L110 109M155 109L156 110L155 109M54 110L55 111L54 110M156 110L157 111L156 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M54 111L55 112L54 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M90 111L91 112L90 111M107 111L108 112L107 111M92.6667 112.333L93.3333 112.667L92.6667 112.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M104 112L105 113L104 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M105 112L106 113L105 112M55 113L56 114L55 113M96.6667 113.333L97.3333 113.667L96.6667 113.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M98.6667 113.333L99.3333 113.667L98.6667 113.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M100 113L100 114L103 114L100 113M157 113L158 114L157 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M55 114L56 115L55 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M156 115L157 116L156 115M56 116L57 117L56 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M156 116L157 117L156 116M55 118L56 119L55 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M155 118L156 119L155 118M54 120L55 121L54 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M53 121L54 122L53 121M154 121L155 122L154 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M52 123L53 124L52 123M139 123L139 124L144 124L139 123M153 123L154 124L153 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M51 124L52 125L51 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M138 124L139 125L138 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M137 125L138 126L137 125M50 126L51 127L50 126M136 126L137 127L136 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M49 127L50 128L49 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M135 127L136 128L135 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefaed",
      stroke: "none"
    },
    d: "M214 127.558C192.788 133.125 202.702 165.643 224 160.467C246.002 155.12 235.77 121.844 214 127.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M353 131L354 132L353 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M354 131L354 132L358 132L354 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4826e3",
      stroke: "none"
    },
    d: "M336 156L337 156L339 148L361 152C361.451 157.517 363.673 170.513 370.185 172.187C378.294 174.271 386.04 165.522 391.82 177.005C396.239 185.784 385.77 188.363 384.408 195.184C383.283 200.818 387.237 208.333 388 214C394.872 208.696 399.413 199.667 403.247 192C406.098 186.299 408.782 180.372 409.7 174C414.851 138.253 379.074 127.08 350 132.464C337.849 134.714 329.317 144.069 336 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M368 131L368 132L372 132L368 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M372 131L373 132L372 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M373 131L374 132L373 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M51 132L52 133L51 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M348.667 132.333L349.333 132.667L348.667 132.333M377.667 132.333L378.333 132.667L377.667 132.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M379 132L380 133L379 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M52 133L53 134L52 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M132 133L133 134L132 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M345 133L346 134L345 133M383 133L384 134L383 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M384 133L385 134L384 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M69 134L70 135L69 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M70 134L71 135L70 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M132.333 134.667L132.667 135.333L132.333 134.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M342 134L343 135L342 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M387 134L388 135L387 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M388 134L389 135L388 134M35 136C34.8652 142.531 33.4478 150.808 25 150.713C19.9144 150.656 16.6974 146.605 12.152 151.152C6.28448 157.022 14.4732 161.586 13.091 167.999C11.6185 174.831 5.47392 173.633 1.6034 177.703C-0.781925 180.211 0.000349683 184.832 0 188C12.6007 190.917 15.9986 198.507 8 209L8 210C15.5794 219.197 18.1588 212.229 26.9992 215.103C33.7321 217.291 34.2448 224.029 35 230C37.9997 230.129 42.7049 231.718 45.3627 229.958C49.6914 227.091 49.7289 221.264 56.0008 220.592C63.1972 219.821 66.3568 229.733 73.8511 224.516C78.826 221.053 74.6568 216.652 75.7623 212C77.7903 203.466 86.1681 204 93 204L94.5934 195.039L87.1173 183.004L94.6466 171.826L93 162C86.5545 162 77.8999 162.17 76.206 154C75.2354 149.319 78.8379 144.897 73.8519 141.487C66.7934 136.659 63.6826 145.388 57.0039 145.257C50.1843 145.123 50.3605 138.911 45.6103 136.042C42.752 134.317 38.1602 135.864 35 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M67 135L68 136L67 135M72 135L73 136L72 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M340 135L341 136L340 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M390 135L391 136L390 135M64 136L65 137L64 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M65 136L66 137L65 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M74 136L75 137L74 136M339 136L340 137L339 136M392 136L393 137L392 136M55 137L56 138L55 137M62 137L63 138L62 137M394 137L395 138L394 137M56 138L57 139L56 138M59 138L60 139L59 138M77 138L78 139L77 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M133 138L134 139L133 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M396 138L397 139L396 138M57 139L58 140L57 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M79 139L80 140L79 139M133.333 139.667L133.667 140.333L133.333 139.667M397 139L398 140L397 139M335 140L336 141L335 140M398 140L399 141L398 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M334 141L335 142L334 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M80 142L80 145L81 145L80 142M111.667 142.333L112.333 142.667L111.667 142.333M105 143L106 144L105 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M106 143L107 144L106 143M113 143L114 144L113 143M333 143L334 144L333 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M101 144L102 145L101 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M114 144L115 145L114 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M134.333 144.667L134.667 145.333L134.333 144.667M333 144L334 145L333 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M80 145L81 146L80 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M115 145L116 146L115 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M403 145L404 146L403 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M80 146L81 147L80 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M100 146L101 147L100 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M133 146L134 147L133 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M404 146L405 147L404 146M131 147L132 148L131 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M99 148L100 149L99 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M129 148L130 149L129 148M339 148L340 149L339 148M405 148L406 149L405 148M127 149L128 150L127 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M339 149C338.305 154.382 337.645 160.695 333.772 164.815C331.038 167.724 325.053 169.335 323.647 173.213C322.043 177.637 326.933 181.859 327.718 186C328.798 191.691 325.444 197.331 326.383 202.985C328.3 214.517 357.176 212.019 346.682 230.867C343.765 236.106 334.21 238.356 329 240.579C314.756 246.657 298.092 251.717 285.004 259.994C277.288 264.873 272.365 274.377 267.8 282C256.998 300.041 244.806 320.691 239 341C225.943 325.111 213.194 300.993 205.212 282C202.699 276.02 203.145 269.729 199.532 264.015C194.294 255.732 175.789 246.86 166 246.229C157.648 245.691 152.775 247.702 144 244.975C139.727 243.647 123.433 236.474 122.06 245.174C121.247 250.326 133.534 255.166 137 257.519C146.759 264.145 155.643 273.684 164 282.001C167.096 285.082 172.373 288.787 173.898 293C175.253 296.743 171.529 301.177 171.225 305C170.762 310.811 173.33 317.361 174.576 323C181.44 354.077 189.509 387.179 207.355 414C218.36 430.539 235.474 440.587 254 426.468C268.488 415.425 279.263 399.843 292 387C292.059 394.078 295.376 402.056 294.166 409C292.401 419.124 284.681 428.035 287.558 439C289.02 444.572 296.03 452.711 302 453.574C305.432 454.07 308.51 451.57 312 451.748C323.701 452.344 334.029 454.781 345 449C351.563 460.277 378.484 457.301 390 458.09C413.283 459.684 437.057 460.162 460 455.21C469.972 453.057 480.924 450.47 487.468 441.996C492.901 434.96 493.78 424.627 493.946 416C494.631 380.468 484.894 343.739 474.72 310C470.032 294.454 464.188 275.671 453.671 263.001C443.116 250.284 419.996 245.599 405 239.6C400.32 237.728 392.052 236.115 388.618 232.301C386.026 229.422 388.011 222.615 387.999 219C387.971 210.081 384.788 201.663 383 193C390.326 190.502 396.733 180.194 389.581 173.653C383.165 167.784 375.504 175.158 369.619 172.018C362.647 168.297 364.266 158.703 359.86 153.603C357.048 150.349 343.533 150.037 339 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M341.667 149.333L342.333 149.667L341.667 149.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M406 149L407 150L406 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M81 150L81 154L82 154L81 150M338 150L338 153L339 153L338 150M344.667 150.333L345.333 150.667L344.667 150.333M97 151L98 152L97 151M124 151L125 152L124 151M333 151L334 152L333 151M349 151L349 152L357 152L349 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M407 151L408 152L407 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M360.333 152.667L360.667 153.333L360.333 152.667M407 152L408 153L407 152M96 153L97 154L96 153M334 153L335 154L334 153M83 154L83 155L86 155L83 154M408 154L409 155L408 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M88 155L89 156L88 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M89.6667 155.333L90.3333 155.667L89.6667 155.333M95 155L96 156L95 155M337.333 155.667L337.667 156.333L337.333 155.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M93 156L94 157L93 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M94 156L95 157L94 156M361.333 156.667L361.667 157.333L361.333 156.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M409 157L410 158L409 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M409 158L410 159L409 158M362.333 160.667L362.667 161.333L362.333 160.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M410 162L411 163L410 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M363 163L364 164L363 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M410 163L411 164L410 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M410 164L410 171L411 171L410 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefaed",
      stroke: "none"
    },
    d: "M45 165.48C22.6053 169.994 29.1968 203.779 52 199.671C74.0228 195.703 66.7227 161.101 45 165.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M364 165L365 166L364 165M365 167L366 168L365 167M366 169L367 170L366 169M367 170L368 171L367 170M377 170L377 171L385 171L377 170M374.667 171.333L375.333 171.667L374.667 171.333M386.667 171.333L387.333 171.667L386.667 171.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M410 171L411 172L410 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M372 172L373 173L372 172M388 172L389 173L388 172M370 173L371 174L370 173M391 175L392 176L391 175M409.333 175.667L409.667 176.333L409.333 175.667M392.333 177.667L392.667 178.333L392.333 177.667M408 179L409 180L408 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M408 180L409 181L408 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M392 182L392 185L393 185L392 182M407 182L408 183L407 182M406 185L407 186L406 185M391 186L392 187L391 186M405 187L406 188L405 187M389 189L390 190L389 189M404 189L405 190L404 189M388 190L389 191L388 190M403 191L404 192L403 191M385 192L386 193L385 192M383 193L383 196L384 196L383 193M402 193L403 194L402 193M401 195L402 196L401 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c95f9",
      stroke: "none"
    },
    d: "M400 197L401 198L400 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M384.333 198.667L384.667 199.333L384.333 198.667M398 200L399 201L398 200M385.333 202.667L385.667 203.333L385.333 202.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M397 202L398 203L397 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M396 203L397 204L396 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M395 205L396 206L395 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M386.333 206.667L386.667 207.333L386.333 206.667M394 206L395 207L394 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc145",
      stroke: "none"
    },
    d: "M393 208L394 209L393 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c78da",
      stroke: "none"
    },
    d: "M392 209L393 210L392 209M387.333 210.667L387.667 211.333L387.333 210.667M390 212L391 213L390 212M389 213L390 214L389 213M388 214L389 215L388 214z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb4);
export default __webpack_public_path__ + "static/media/db4.e2085e2f5705a195080c0102af40eafc.svg";
export { ForwardRef as ReactComponent };